var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inputClass"},[_c('vue-select',{attrs:{"name":_vm.name,"id":_vm.id,"endpointUrl":_vm.endpoint,"selectedTagsData":_vm.selectedTags}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }